import AppTag from './AppTag'

export default AppTag